import React, { useState } from 'react';
import { Card, Row, Col } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from '../../widgets';
import { isToday, usePermission } from "../../../helpers/common";
import ScoutForm from '../scout/scoutForm';
import { deleteScoutGroup } from '../../../actions/scout-kanban';

const ColumnHeader = (props) => {
    const { scoutGroupId } = props;
    const dispatch = useDispatch();
    const { farmId } = useParams();
    const allow = usePermission();
    const isAllowDeleteScoutGroup = allow("field-grouping", "delete");
    const isAllowEditScoutGroup = allow("field-grouping", "edit");
    const [show, setShow] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleDeleteClose = () => setDeleteModal(false);
    const handleDeleteShow = () => setDeleteModal(true);
    const sgListById = useSelector((state) => state.scoutKanban.sgListById);
    const range = useSelector((state) => state.analyze.searchParams.range);
    if (!sgListById[scoutGroupId]) return <></>;

    const handleDeleteConfim = (scoutGroupId) => {
        dispatch(deleteScoutGroup({ scout_group_uuid: scoutGroupId, farm_uuid: farmId }));
        handleDeleteClose();
    }
    return <>
        <div className="kanban-column-header">
            <Card className='scout_column_card'>
                <Card.Header className="d-flex flex-column ">
                    <Row>
                        <Col className="col-9">
                            <Card.Title as="div" /* className={`${crew.is_end_crew && `text-end`}`} */>
                                <div>{sgListById[scoutGroupId]['scout_group_name']}{sgListById[scoutGroupId].isChanged && <sup className="super-set">*</sup>}</div>
                            </Card.Title>
                        </Col>
                        <Col className="col-3">
                            {isToday(range) && <div className='scout_actions'>
                                {isAllowEditScoutGroup && <i className="fa fa-pencil card-edit" title="edit" onClick={handleShow} />}
                                {isAllowDeleteScoutGroup && <i className="fa fa-trash card-edit" title="Delete" onClick={handleDeleteShow} />}
                            </div>}

                        </Col>
                    </Row>
                </Card.Header>
            </Card>
        </div>
        <ScoutForm show={show} onHide={handleClose} scoutGroupData={sgListById[scoutGroupId] ? sgListById[scoutGroupId] : null} />
        <Modal.Confirm
            show={deleteModal}
            onConfirm={() => handleDeleteConfim(scoutGroupId)}
            onHide={() => handleDeleteClose()}
            iconClassName="fa fa-trash"
            body={`Do you really want to delete these ${sgListById[scoutGroupId]['scout_group_name']}?`}
        />

    </>
}

export default ColumnHeader